import { render, staticRenderFns } from "./CreateIvyActivation.vue?vue&type=template&id=a8714fc8&"
import script from "./CreateIvyActivation.vue?vue&type=script&lang=js&"
export * from "./CreateIvyActivation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports